import React, {Component} from 'react';
import './Exams.scss';
import * as constants from "../../../const/constants";
import Header from "../../../components/Header/Header";
import {Button, Card, Col, Container, Row} from "reactstrap";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import {connect} from "react-redux";
import * as commonFunc from "../../../utils/commonFunc";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionClassCreator from "../../../store/domain/classes/action";
import NotFound from "../../../components/NotFound/NotFound";
import {lang, language} from "../../../const/language";
import * as paperServicess from "../../../services/papers";
import {withRouter} from "react-router";
import moment from "moment";

class App extends Component {

    state = {
        allPapers: [],
    };

    componentDidMount() {
        this.getAllTriedPapers()
    }

    getAllTriedPapers = async () => {
        this.props.spinnerHandler({isSpin: true, type: 15});
        const data = {
            "studentId": this.props.userObj.id
        };
        await paperServicess.viewTriedQuizzes(data)
            .then(response => {
                this.props.spinnerHandler(false);

                if (response.success) {

                    this.setState({
                        allPapers: response.body
                    })
                } else {
                    commonFunc.notifyMessage(response.message, response.status);
                }
            })
    };


    viewLeaderBoard = (item) => {
        const data = {
            "classId": item.cid,
            "quizId": item.id
        };
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_LEADERBOARD_ROUTE}`,
            state: {data}
        })
    };
    checkTeacherComment = (item) => {
        console.log(item);
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_GET_TEACHER_COMMENT_ROUTE}`,
            state: {...item}
        })

    };

    compareAnswers = (item) => {
        const data = {
            "classId": item.cid,
            "quizId": item.id,
            "enrollId": item.enrollId,
            "totalQuestions": item.noOfQuestions,
            "totalAnswers": item.noOfAnswersPerQuestion,
        };
        this.props.history.push({
            pathname: `${constants.BASE_ROUTE}${constants.HOME_COMPARE_ANSWERS_ROUTE}`,
            state: {data}
        })
    };

    render() {

        return (
            <div>
                <Header active={4}/>
                <main ref="main" className={"my-class"}>

                    <section>
                        <Container>
                            <div>
                                <h3 className={"teach-black-text head-topic align-center"}>{language[lang].triydPaperText}</h3>
                            </div>
                            {
                                this.state.allPapers.length === 0 &&
                                <NotFound/>
                            }
                            <div>

                                {this.state.allPapers.map((item, index) =>

                                    <div key={index}>
                                        <Row className={"view-papers row shadow "}>
                                            <Col lg="3">
                                                <Card className={"mark-wrapper"}>
                                                    <span className={"marks-labal"}> Marks</span>
                                                    {item.quizType === 'MCQ' ?
                                                        <span
                                                            className={"mark-number"}>{item.marks + ' out of ' + item.noOfQuestions}</span> :
                                                        <span
                                                            className={"mark-number"}>{item.marks}</span>
                                                    }

                                                </Card>
                                            </Col>
                                            <Col lg="6">
                                                <h2 className={"vp-topic"}>{item.title}</h2>
                                                {
                                                    item.startTime !== null &&
                                                    <p> {language[lang].tryDateText} {` ${moment(item.startTime.replace("Z", "")).format("YYYY MMM DD ")}`} , {` ${moment(item.startTime.replace("Z", "")).format("h mm a ")}`} </p>
                                                }

                                                {
                                                    item.endTime !== null &&
                                                    <p> {language[lang].submitDateText} {` ${moment(item.endTime.replace("Z", "")).format("YYYY MMM DD ")}`}, {` ${moment(item.endTime.replace("Z", "")).format("h mm a ")}`}</p>
                                                }
                                                {
                                                    item.answersState === 1 && <span
                                                        className={"submit-unsucces"}> {language[lang].suddenlyLeftText} </span>
                                                }
                                                {
                                                    item.answersState === 2 && <span
                                                        className={"submit-succes"}> {language[lang].sumbitedSuccesfullyText} </span>
                                                }

                                            </Col>
                                            <Col lg="3">

                                                <a href={item.questionPaperUrl} target="blank">

                                                    <Button className={" com-btn bold-text"}

                                                    >
                                                        {language[lang].viewPaperText}
                                                    </Button>
                                                </a>
                                                <Button className={" com-btn bold-text"}
                                                        onClick={() => this.viewLeaderBoard(item)}
                                                >
                                                    {language[lang].viewLeaderBoardText}
                                                </Button>
                                                {
                                                    item.quizType === 'MCQ' &&
                                                    <Button className={"com-btn bold-text"}
                                                            onClick={() => this.compareAnswers(item)}>
                                                        {language[lang].comapreAnswerText}
                                                    </Button>
                                                }

                                                {
                                                    item.quizType === 'ESSAY' ?
                                                        <Button className={"com-btn bold-text"}
                                                                onClick={() => this.checkTeacherComment(item)}>
                                                            {language[lang].teacherComment}
                                                        </Button> : null
                                                }

                                            </Col>

                                        </Row>


                                    </div>
                                )}

                            </div>

                            <div>

                                {this.state.allPapers === undefined && <NotFound/>}
                            </div>


                        </Container>
                    </section>
                </main>
                <CardsFooter/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    purchaseClasses: state.classes.purchaseClasses,
    userObj: state.student.userObj,
    isSpinner: state.spinner.isSpinner,
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    fetchAllPurchasedClass: data => dispatch(actionClassCreator.fetchAllPurchasedClass(data)),
    selectMyClassPagination: data => dispatch(actionClassCreator.selectMyClassPagination(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));

/* Created By Janitha Prashad Katukenda
 jpk Created on Tue Dec 22 2020
Copyright (c) 2020 Ceyentra Technologies
EDULAB */
